import ChangeAddressModal, { ChangeAddressModalProps } from './ChangeAddressModal';

export type { ChangeAddressModalProps };
export default ChangeAddressModal;
